import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3","key":"svg-0"}],["path",{"d":"M6 8v3a1 1 0 0 0 1 1h3","key":"svg-1"}],["path",{"d":"M10 8v8","key":"svg-2"}]]

const IconNumber46Small = createReactComponent('outline', 'number-46-small', 'Number46Small', __iconNode);

export default IconNumber46Small;